import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Avatar, Select } from 'antd';
import { Link /* useHistory */ } from 'react-router-dom';

import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './auth-info-style';
import { Popover } from '../../popup/popup';

import { logOut } from '../../../redux/authentication/actionCreator';
import { selectSucursal, fetchSucursales } from '../../../redux/sucursal/actionCreator';
import Heading from '../../heading/heading';

const { Option } = Select;

const AuthInfo = () => {
  const login = useSelector(state => state.auth.login);
  const sucursal = useSelector(state => state.sucursal?.current);
  const sucursalesList = useSelector(state => state.sucursal?.list || []);
  const dispatch = useDispatch();
  // const history = useHistory();

  // Cargar sucursales si es admin y no hay lista
  useEffect(() => {
    if (login?.user?.role === 'admin' && sucursalesList.length === 0) {
      dispatch(fetchSucursales());
    }
  }, [login, sucursalesList.length, dispatch]);

  const SignOut = e => {
    e.preventDefault();
    dispatch(logOut());
  };

  const handleSucursalChange = sucursalId => {
    const selectedSucursal = sucursalesList.find(s => s.id === sucursalId);
    if (selectedSucursal) {
      dispatch(selectSucursal(selectedSucursal));
    }
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <img src={require('../../../static/img/avatar/chat-auth.png')} alt="" />
          <figcaption>
            <Heading as="h5">{login?.user?.name || 'Usuario'}</Heading>
            <p>{login?.user?.role || 'Puesto'}</p>
          </figcaption>
        </figure>

        {/* Indicador de sucursal actual */}
        <div
          className="user-dropdwon__sucursal"
          style={{
            padding: '10px 20px',
            borderTop: '1px solid #f0f0f0',
            borderBottom: '1px solid #f0f0f0',
            marginBottom: '10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '5px',
            }}
          >
            <FeatherIcon icon="map-pin" size={14} />
            <span style={{ fontSize: '12px', color: '#888' }}>Sucursal:</span>
          </div>
          <div style={{ fontSize: '14px', fontWeight: '500' }}>{sucursal?.nombre || 'Sin asignar'}</div>

          {/* Solo admin puede cambiar de sucursal */}
          {login?.user?.role === 'admin' && sucursalesList.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              <Select
                value={sucursal?.id}
                onChange={handleSucursalChange}
                style={{ width: '100%' }}
                placeholder="Cambiar sucursal"
                disabled={sucursalesList.length === 1}
                getPopupContainer={trigger => trigger.parentNode}
                dropdownStyle={{ zIndex: 10000 }}
              >
                {sucursalesList.map(s => (
                  <Option key={s.id} value={s.id}>
                    {s.nombre}
                  </Option>
                ))}
              </Select>
              {sucursalesList.length === 1 && (
                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                  Solo tienes acceso a esta sucursal
                </div>
              )}
            </div>
          )}
        </div>

        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <FeatherIcon icon="log-out" /> Cerrar Sesión
        </Link>
      </div>
    </UserDropDwon>
  );

  return (
    <InfoWraper>
      {/* <Message />
      <Notification />

      <Settings />
      <Support />
      <div className="nav-author">
        <Dropdown placement="bottomRight" content={country} trigger="click">
          <Link to="#" className="head-example">
            <img src={require(`../../../static/img/flag/${flag}.png`)} alt="" />
          </Link>
        </Dropdown>
      </div>
      */}

      {/* Indicador de sucursal visible en el header */}
      {sucursal && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 12px',
            background: '#f0f7ff',
            border: '1px solid #91d5ff',
            borderRadius: '16px',
            marginRight: '15px',
            fontSize: '14px',
            fontWeight: '500',
            color: '#0050b3',
            height: '28px',
          }}
        >
          <FeatherIcon icon="map-pin" size={12} style={{ color: '#1890ff' }} />
          <span>{sucursal.nombre}</span>
        </div>
      )}

      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click" overlayStyle={{ zIndex: 9999 }}>
          <Link to="#" className="head-example">
            <Avatar src={require('../../../static/img/avatar/chat-auth.png')} />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
};

export default AuthInfo;
